// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bff0814f","455":"359114f8","977":"9d98acbb"}[chunkId] + ".chunk.js";
};